import React, { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { PasswordInput } from "@/components/auth/PasswordInput";
import { SocialLogin } from "@/components/auth/SocialLogin";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [params] = useSearchParams();
  const next = params.get("next");
  const safeNext = next && next.startsWith("/") && !next.startsWith("//") ? next : "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login(email, password);
      if (res.deletionCancelled) { toast.success("Bentornato! La cancellazione del tuo account è stata annullata.", { duration: 8000 }); } else { toast.success("Accesso effettuato"); }
      nav(safeNext);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore di accesso");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12">
      <div>
        <span className="overline text-gold">Accesso portale</span>
        <h1 className="font-display text-4xl font-bold mt-2">Bentornato/a.</h1>
        <p className="text-slate-600 mt-3">Accedi con le tue credenziali per visualizzare prezzi, contatti e strumenti operativi.</p>
        <div className="mt-8"><SocialLogin/></div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="overline text-slate-500 mb-2 block">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:border-gold"/>
          </div>
          <div>
            <div className="flex items-center justify-between mb-2">
              <label className="overline text-slate-500 block">Password</label>
              <Link to="/password-dimenticata" data-testid="forgot-link" className="text-xs text-gold font-semibold hover:underline">Password dimenticata?</Link>
            </div>
            <PasswordInput testId="login-password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:border-gold"/>
          </div>
          <button data-testid="login-submit" disabled={loading} className="btn-pill-gold w-full justify-center"><LogIn className="w-4 h-4"/>{loading?"Accesso…":"Entra"}</button>
          <p className="text-sm text-slate-500 text-center">Non hai un account? <Link to="/registrati" className="text-gold font-semibold">Iscriviti</Link></p>
        </form>
      </div>
      <div className="p-8 rounded-2xl bg-navy text-white border border-gold/20 h-fit">
        <div className="overline text-gold mb-4">Perché accedere</div>
        <ul className="space-y-3 text-sm text-slate-300">
          <li>Enti e Organizzatori: prezzi, contatti, preventivi e contratti PDF.</li>
          <li>Artisti e Fornitori: profilo, sezione Consigliati, sponsorizzate dalla Dashboard e richieste di prenotazione.</li>
          <li>Privati: richiesta evento gestita dal Portale.</li>
          <li>Chat diretta 1-to-1 con i professionisti.</li>
        </ul>
      </div>
    </div>
  );
}
